import { render } from "./ShopCarWaimai.vue?vue&type=template&id=53d812d9&scoped=true"
import script from "./ShopCarWaimai.vue?vue&type=script&lang=js"
export * from "./ShopCarWaimai.vue?vue&type=script&lang=js"

import "./ShopCarWaimai.vue?vue&type=style&index=0&id=53d812d9&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d812d9"]])

export default __exports__